var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"\n    scrollbar\n    h-screen\n    overflow-y-auto\n    text-white\n    top-0\n    lg:absolute\n    bg-gray-900\n    lg:block lg:z-40\n  ",class:[
    _vm.style[_vm.mobilePosition],
    _vm.open
      ? 'absolute duration-500 ease-in transition-all w-8/12 z-40 sm:w-5/12 md:w-64'
      : 'duration-700 ease-out hidden transition-all lg:w-24' ]},[_c('div',{staticClass:"pb-32 lg:pb-12"},[_c('sidenav-header'),_c('sidenav-items')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }